import { Store } from 'types';
import { trackEvent } from 'utils/trackEvent';

import {
	analyticsAffiliationSelector,
	analyticsCarIdSelector,
} from '../../../../../store/selectors';

export const pushPurchaseToDataLayer = async (state: Store, response: Response): Promise<void> => {
	const { leaseCarData, plCustomer, chosenLeaseCar } = state;
	const groupedPricePoints = leaseCarData?.privateLeaseData.groupedPricePoints;

	const jsonBody = await response.json();
	const transactionReference: string | null = jsonBody?.id;

	const kilometrageObject = groupedPricePoints
		? groupedPricePoints[Number(chosenLeaseCar.duration)].kilometrages.find(
				(k) => k.mileage === Number(chosenLeaseCar.kilometrage)
			)
		: undefined;

	const affiliation = analyticsAffiliationSelector(state);
	const analyticsCarId = analyticsCarIdSelector(state);

	// GA4 track event
	if (leaseCarData && kilometrageObject)
		trackEvent({
			event: 'purchase',
			ecommerce: {
				transaction_id: transactionReference,
				affiliation,
				value: chosenLeaseCar.totalPrice,
				currency: 'EUR',
				...(chosenLeaseCar.paymentInAdvanceChoice ? { coupon: 'vooruitbetalen' } : {}),
				items: [
					{
						item_id: analyticsCarId,
						item_name: leaseCarData.vehicleData.model,
						item_brand: leaseCarData.vehicleData.make,
						item_category: 'Auto',
						item_category2: affiliation,
						item_category3: `${chosenLeaseCar.duration} maanden`,
						item_category4: kilometrageObject.description,
						item_category5: plCustomer.isMember ? 'lid' : 'niet-lid',
						...(chosenLeaseCar.paymentInAdvanceChoice ? { item_variant: 'vooruitbetalen' } : {}),
						price: chosenLeaseCar.totalPrice,
						quantity: 1,
					},
				],
			},
		});
};
